import { TIPS } from '@ice-web-app/shared-constants';
import { useCurrentUserStore } from '@ice-web-app/shared-store';
import { Box, Divider, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Ecosystem from './Ecosystem/Ecosystem';
import MiniNavbarLinks from './Links/MiniNavbarLinks';
import Member from './Member/Member';
import MicroSystem from './MicroSystem/MicroSystem';

const MiniNavbar = () => {
  const [menu, setMenu] = useState<'ecosystem' | 'microSystem' | 'member' | 'none'>('none');
  const { currentEcosystem, setCurrentMicrosystem, setCurrentUserType } = useCurrentUserStore();

  useEffect(() => {
    if (!currentEcosystem) return;
    const firstMicro = currentEcosystem.microsystems?.[0];
    if (firstMicro) {
      setCurrentMicrosystem(firstMicro);
      const firstUserType = firstMicro.userTypes?.[0];
      if (firstUserType) {
        setCurrentUserType(firstUserType);
      }
    }
  }, [currentEcosystem]);

  return (
    <PerfectScrollbar style={{ width: 122 }}>
      <Stack sx={{ width: 1, alignItems: 'center', pt: (theme) => theme.spacing(6) }} gap={4}>
        <Stack alignItems="center" spacing={4} position="relative">
          <Box
            height="100%"
            width="75%"
            data-tour={TIPS.LAYOUT.SIDEBAR.MINI_SIDEBAR_TOP_SECTION.DATA}
            position="absolute"
          />
          <Ecosystem setMenu={setMenu} />
          <MicroSystem menu={menu} setMenu={setMenu} />
          <Member menu={menu} setMenu={setMenu} />
        </Stack>
        <Divider orientation="horizontal" flexItem sx={{ my: 2 }} />
        <MiniNavbarLinks />
      </Stack>
    </PerfectScrollbar>
  );
};
export default MiniNavbar;
